var cov_gcyrrewti = function () {
  var path = "/Users/spana/SHEIN/shineout/src/hoc/pagable.tsx",
      hash = "367a0469bd77df19562124ab8cef804f894572c6",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/hoc/pagable.tsx",
    statementMap: {
      "0": {
        start: {
          line: 18,
          column: 2
        },
        end: {
          line: 18,
          column: 39
        }
      },
      "1": {
        start: {
          line: 18,
          column: 28
        },
        end: {
          line: 18,
          column: 39
        }
      },
      "2": {
        start: {
          line: 19,
          column: 2
        },
        end: {
          line: 19,
          column: 48
        }
      },
      "3": {
        start: {
          line: 19,
          column: 37
        },
        end: {
          line: 19,
          column: 48
        }
      },
      "4": {
        start: {
          line: 21,
          column: 16
        },
        end: {
          line: 21,
          column: 52
        }
      },
      "5": {
        start: {
          line: 22,
          column: 2
        },
        end: {
          line: 22,
          column: 50
        }
      },
      "6": {
        start: {
          line: 26,
          column: 2
        },
        end: {
          line: 76,
          column: 3
        }
      },
      "7": {
        start: {
          line: 28,
          column: 6
        },
        end: {
          line: 28,
          column: 18
        }
      },
      "8": {
        start: {
          line: 30,
          column: 17
        },
        end: {
          line: 30,
          column: 40
        }
      },
      "9": {
        start: {
          line: 31,
          column: 6
        },
        end: {
          line: 34,
          column: 7
        }
      },
      "10": {
        start: {
          line: 36,
          column: 6
        },
        end: {
          line: 36,
          column: 54
        }
      },
      "11": {
        start: {
          line: 40,
          column: 6
        },
        end: {
          line: 40,
          column: 59
        }
      },
      "12": {
        start: {
          line: 47,
          column: 26
        },
        end: {
          line: 47,
          column: 36
        }
      },
      "13": {
        start: {
          line: 48,
          column: 20
        },
        end: {
          line: 48,
          column: 57
        }
      },
      "14": {
        start: {
          line: 49,
          column: 6
        },
        end: {
          line: 58,
          column: 7
        }
      },
      "15": {
        start: {
          line: 62,
          column: 27
        },
        end: {
          line: 62,
          column: 49
        }
      },
      "16": {
        start: {
          line: 63,
          column: 6
        },
        end: {
          line: 63,
          column: 42
        }
      },
      "17": {
        start: {
          line: 64,
          column: 6
        },
        end: {
          line: 64,
          column: 47
        }
      },
      "18": {
        start: {
          line: 64,
          column: 20
        },
        end: {
          line: 64,
          column: 47
        }
      },
      "19": {
        start: {
          line: 68,
          column: 45
        },
        end: {
          line: 68,
          column: 55
        }
      },
      "20": {
        start: {
          line: 69,
          column: 20
        },
        end: {
          line: 69,
          column: 52
        }
      },
      "21": {
        start: {
          line: 71,
          column: 6
        },
        end: {
          line: 74,
          column: 7
        }
      }
    },
    fnMap: {
      "0": {
        name: "getData",
        decl: {
          start: {
            line: 17,
            column: 9
          },
          end: {
            line: 17,
            column: 16
          }
        },
        loc: {
          start: {
            line: 17,
            column: 99
          },
          end: {
            line: 23,
            column: 1
          }
        },
        line: 17
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 25,
            column: 15
          },
          end: {
            line: 25,
            column: 16
          }
        },
        loc: {
          start: {
            line: 25,
            column: 83
          },
          end: {
            line: 77,
            column: 1
          }
        },
        line: 25
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 27,
            column: 4
          },
          end: {
            line: 27,
            column: 5
          }
        },
        loc: {
          start: {
            line: 27,
            column: 43
          },
          end: {
            line: 37,
            column: 5
          }
        },
        line: 27
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 39,
            column: 4
          },
          end: {
            line: 39,
            column: 5
          }
        },
        loc: {
          start: {
            line: 39,
            column: 41
          },
          end: {
            line: 41,
            column: 5
          }
        },
        line: 39
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 43,
            column: 4
          },
          end: {
            line: 43,
            column: 5
          }
        },
        loc: {
          start: {
            line: 46,
            column: 91
          },
          end: {
            line: 59,
            column: 5
          }
        },
        line: 46
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 61,
            column: 4
          },
          end: {
            line: 61,
            column: 5
          }
        },
        loc: {
          start: {
            line: 61,
            column: 52
          },
          end: {
            line: 65,
            column: 5
          }
        },
        line: 61
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 67,
            column: 4
          },
          end: {
            line: 67,
            column: 5
          }
        },
        loc: {
          start: {
            line: 67,
            column: 13
          },
          end: {
            line: 75,
            column: 5
          }
        },
        line: 67
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 18,
            column: 39
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 18,
            column: 39
          }
        }, {
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 18,
            column: 39
          }
        }],
        line: 18
      },
      "1": {
        loc: {
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 19,
            column: 48
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 19,
            column: 48
          }
        }, {
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 19,
            column: 48
          }
        }],
        line: 19
      },
      "2": {
        loc: {
          start: {
            line: 30,
            column: 17
          },
          end: {
            line: 30,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 30,
            column: 17
          },
          end: {
            line: 30,
            column: 34
          }
        }, {
          start: {
            line: 30,
            column: 38
          },
          end: {
            line: 30,
            column: 40
          }
        }],
        line: 30
      },
      "3": {
        loc: {
          start: {
            line: 32,
            column: 17
          },
          end: {
            line: 32,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 32,
            column: 17
          },
          end: {
            line: 32,
            column: 27
          }
        }, {
          start: {
            line: 32,
            column: 31
          },
          end: {
            line: 32,
            column: 48
          }
        }, {
          start: {
            line: 32,
            column: 52
          },
          end: {
            line: 32,
            column: 53
          }
        }],
        line: 32
      },
      "4": {
        loc: {
          start: {
            line: 33,
            column: 18
          },
          end: {
            line: 33,
            column: 35
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 33,
            column: 18
          },
          end: {
            line: 33,
            column: 29
          }
        }, {
          start: {
            line: 33,
            column: 33
          },
          end: {
            line: 33,
            column: 35
          }
        }],
        line: 33
      },
      "5": {
        loc: {
          start: {
            line: 40,
            column: 13
          },
          end: {
            line: 40,
            column: 59
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 40,
            column: 13
          },
          end: {
            line: 40,
            column: 40
          }
        }, {
          start: {
            line: 40,
            column: 44
          },
          end: {
            line: 40,
            column: 59
          }
        }],
        line: 40
      },
      "6": {
        loc: {
          start: {
            line: 48,
            column: 20
          },
          end: {
            line: 48,
            column: 57
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 48,
            column: 42
          },
          end: {
            line: 48,
            column: 53
          }
        }, {
          start: {
            line: 48,
            column: 56
          },
          end: {
            line: 48,
            column: 57
          }
        }],
        line: 48
      },
      "7": {
        loc: {
          start: {
            line: 64,
            column: 6
          },
          end: {
            line: 64,
            column: 47
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 64,
            column: 6
          },
          end: {
            line: 64,
            column: 47
          }
        }, {
          start: {
            line: 64,
            column: 6
          },
          end: {
            line: 64,
            column: 47
          }
        }],
        line: 64
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/hoc/pagable.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import { PureComponent } from '../component';
import Pagination from '../Pagination';

function getData(data, pager) {
  cov_gcyrrewti.f[0]++;
  cov_gcyrrewti.s[0]++;

  if (!Array.isArray(data)) {
    cov_gcyrrewti.b[0][0]++;
    cov_gcyrrewti.s[1]++;
    return data;
  } else {
    cov_gcyrrewti.b[0][1]++;
  }

  cov_gcyrrewti.s[2]++;

  if (data.length <= pager.pageSize) {
    cov_gcyrrewti.b[1][0]++;
    cov_gcyrrewti.s[3]++;
    return data;
  } else {
    cov_gcyrrewti.b[1][1]++;
  }

  var start = (cov_gcyrrewti.s[4]++, (pager.current - 1) * pager.pageSize);
  cov_gcyrrewti.s[5]++;
  return data.slice(start, start + pager.pageSize);
}

export default function (Component) {
  cov_gcyrrewti.f[1]++;
  cov_gcyrrewti.s[6]++;
  return (
    /*#__PURE__*/
    function (_PureComponent) {
      _inherits(_class, _PureComponent);

      var _super = _createSuper2(_class);

      function _class(props) {
        var _this;

        _classCallCheck(this, _class);

        cov_gcyrrewti.f[2]++;
        cov_gcyrrewti.s[7]++;
        _this = _super.call(this, props);
        var pp = (cov_gcyrrewti.s[8]++, (cov_gcyrrewti.b[2][0]++, props.pagination) || (cov_gcyrrewti.b[2][1]++, {}));
        cov_gcyrrewti.s[9]++;
        _this.state = {
          current: (cov_gcyrrewti.b[3][0]++, pp.current) || (cov_gcyrrewti.b[3][1]++, pp.defaultCurrent) || (cov_gcyrrewti.b[3][2]++, 1),
          pageSize: (cov_gcyrrewti.b[4][0]++, pp.pageSize) || (cov_gcyrrewti.b[4][1]++, 10)
        };
        cov_gcyrrewti.s[10]++;
        _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
        return _this;
      }

      _createClass(_class, [{
        key: "getProp",
        value: function getProp(key) {
          cov_gcyrrewti.f[3]++;
          cov_gcyrrewti.s[11]++;
          return (cov_gcyrrewti.b[5][0]++, this.props.pagination[key]) || (cov_gcyrrewti.b[5][1]++, this.state[key]);
        }
      }, {
        key: "getPager",
        value: function getPager(data, pagination) {
          cov_gcyrrewti.f[4]++;

          var _ref = (cov_gcyrrewti.s[12]++, this.props),
              loading = _ref.loading;

          var total = (cov_gcyrrewti.s[13]++, Array.isArray(data) ? (cov_gcyrrewti.b[6][0]++, data.length) : (cov_gcyrrewti.b[6][1]++, 0));
          cov_gcyrrewti.s[14]++;
          return Object.assign({
            current: this.getProp('current'),
            pageSize: this.getProp('pageSize'),
            total: total,
            disabled: !!loading
          }, pagination, {
            onChange: this.handleChange
          });
        }
      }, {
        key: "handleChange",
        value: function handleChange(current, pageSize) {
          cov_gcyrrewti.f[5]++;

          var _ref2 = (cov_gcyrrewti.s[15]++, this.props.pagination),
              onChange = _ref2.onChange;

          cov_gcyrrewti.s[16]++;
          this.setState({
            current: current,
            pageSize: pageSize
          });
          cov_gcyrrewti.s[17]++;

          if (onChange) {
            cov_gcyrrewti.b[7][0]++;
            cov_gcyrrewti.s[18]++;
            onChange(current, pageSize);
          } else {
            cov_gcyrrewti.b[7][1]++;
          }
        }
      }, {
        key: "render",
        value: function render() {
          cov_gcyrrewti.f[6]++;

          var _ref3 = (cov_gcyrrewti.s[19]++, this.props),
              pagination = _ref3.pagination,
              data = _ref3.data,
              props = _objectWithoutProperties(_ref3, ["pagination", "data"]);

          var pager = (cov_gcyrrewti.s[20]++, this.getPager(data, pagination));
          cov_gcyrrewti.s[21]++;
          return [
          /*#__PURE__*/
          React.createElement(Component, Object.assign({
            key: "origin",
            data: getData(data, pager)
          }, props, {
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 72,
              columnNumber: 9
            }
          })),
          /*#__PURE__*/
          React.createElement(Pagination, Object.assign({
            key: "pager"
          }, pager, {
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 73,
              columnNumber: 9
            }
          }))];
        }
      }]);

      return _class;
    }(PureComponent)
  );
}